<template>
<div class="page-padding">
    
    

            <video width="100%" height="100%" loop playsinline autoplay muted>
                <source :src="'/api/image/get/video/'+video" type="video/mp4" >
            </video>


    </div>
</template>
<script>
export default ({

    name: "BannerVideo",

    props: {
        video:{
          type:String,
          default:null
      }
    }

});
</script>
<style scoped>
    .page-padding {
        padding: 2%;;
    }
</style>